// ============================================================================
// MÓDULO ACADEMIA: CONSTANTES & TAXONOMIA (V9.0 - SCHEMA RICO 30 CAMPOS)
// ARQUIVO: src/6_Academia_Constants.js
// OBJETIVO: Mapeamento completo dos metadados da Engenharia Reversa (OAB).
// ============================================================================

export const ACADEMIA_CONSTANTS = {
    // 1. ÁREAS DO DIREITO (FILTRO MESTRE)
    SUBJECTS: {
        'ETICA': { label: 'Ética Profissional', color: 'orange', icon: 'fa-balance-scale' },
        'CONST': { label: 'Direito Constitucional', color: 'blue', icon: 'fa-landmark' },
        'ADMIN': { label: 'Direito Administrativo', color: 'gray', icon: 'fa-building-columns' },
        'CIVIL': { label: 'Direito Civil', color: 'green', icon: 'fa-users' },
        'PROC_CIVIL': { label: 'Processo Civil', color: 'emerald', icon: 'fa-gavel' },
        'PENAL': { label: 'Direito Penal', color: 'red', icon: 'fa-handcuffs' },
        'PROC_PENAL': { label: 'Processo Penal', color: 'rose', icon: 'fa-user-secret' },
        'TRABALHO': { label: 'Direito do Trabalho', color: 'cyan', icon: 'fa-briefcase' },
        'PROC_TRABALHO': { label: 'Processo do Trabalho', color: 'sky', icon: 'fa-user-tie' },
        'TRIBUTARIO': { label: 'Direito Tributário', color: 'yellow', icon: 'fa-coins' },
        'EMPRESARIAL': { label: 'Direito Empresarial', color: 'indigo', icon: 'fa-building' },
        'HUMANOS': { label: 'Direitos Humanos', color: 'pink', icon: 'fa-dove' },
        'AMBIENTAL': { label: 'Direito Ambiental', color: 'teal', icon: 'fa-leaf' },
        'ECA': { label: 'ECA', color: 'purple', icon: 'fa-child' },
        'CONSUMIDOR': { label: 'Direito do Consumidor', color: 'lime', icon: 'fa-shopping-cart' },
        'INTERNACIONAL': { label: 'Direito Internacional', color: 'slate', icon: 'fa-globe' },
        'FILOSOFIA': { label: 'Filosofia do Direito', color: 'zinc', icon: 'fa-brain' },
        'PREVIDENCIARIO': { label: 'Direito Previdenciário', color: 'amber', icon: 'fa-blind' },
        'ELEITORAL': { label: 'Direito Eleitoral', color: 'fuchsia', icon: 'fa-vote-yea' },
        'FINANCEIRO': { label: 'Direito Financeiro', color: 'gold', icon: 'fa-money-bill-wave' }
    },

    // 2. BANCAS EXAMINADORAS (ORIGEM)
    EXAM_BANKS: [
        { id: 'FGV', label: 'FGV (Fundação Getúlio Vargas)' },
        { id: 'CEBRASPE', label: 'CEBRASPE / CESPE' },
        { id: 'VUNESP', label: 'VUNESP' },
        { id: 'FCC', label: 'FCC (Fundação Carlos Chagas)' },
        { id: 'CESGRANRIO', label: 'Cesgranrio' },
        { id: 'AUTORAL', label: 'Questão Autoral (RDA)' }
    ],

    // 3. ANOS DE APLICAÇÃO (Dinâmico + Histórico)
    YEARS: Array.from({length: 25}, (_, i) => new Date().getFullYear() - i), // [2026...2001]

    // 4. TIPOS DE NORMA (ORIGEM LEGISLATIVA - SCHEMA 30 CAMPOS)
    NORM_TYPES: {
        'CF': { label: 'Constituição Federal', color: 'blue' },
        'LEI_FED': { label: 'Lei Federal / Código', color: 'green' },
        'LEI_COMP': { label: 'Lei Complementar', color: 'teal' },
        'DECRETO': { label: 'Decreto', color: 'gray' },
        'SUMULA': { label: 'Súmula (STF/STJ/TST)', color: 'red' },
        'SUMULA_VINC': { label: 'Súmula Vinculante', color: 'red' },
        'OJ': { label: 'Orientação Jurisprudencial (OJ)', color: 'orange' },
        'DOUTRINA': { label: 'Doutrina', color: 'purple' },
        'REGIMENTO': { label: 'Regimento Interno', color: 'gray' },
        'JURISPRUDENCIA': { label: 'Jurisprudência (Julgado)', color: 'indigo' },
        'RES_ADM': { label: 'Resolução Administrativa', color: 'slate' }
    },

    // 5. STATUS DA QUESTÃO (JURIDICAMENTE)
    QUESTION_STATUS: {
        'VALIDA': { label: 'Válida / Vigente', color: 'green', icon: 'fa-check' },
        'ANULADA': { label: 'Anulada pela Banca', color: 'red', icon: 'fa-ban' },
        'DESATUALIZADA': { label: 'Desatualizada (Lei revogada)', color: 'orange', icon: 'fa-history' },
        'ADAPTADA': { label: 'Adaptada (Atualizada)', color: 'blue', icon: 'fa-wrench' },
        'SUBNORMAL': { label: 'Gabarito Alterado', color: 'yellow', icon: 'fa-exclamation-triangle' }
    },

    // 6. STATUS NORMATIVO (ANÁLISE DE VIGÊNCIA LEGISLATIVA)
    NORMATIVE_STATUS: {
        'VIGENTE': { label: 'Norma Vigente', desc: 'A lei aplicada na época ainda vale hoje.' },
        'REVOGADA': { label: 'Norma Revogada', desc: 'A lei mudou. Cuidado ao estudar!' },
        'ALTERADA': { label: 'Texto Alterado', desc: 'Houve mudança parcial na redação (Lei nova).' },
        'SUPERADA': { label: 'Jurisprudência Superada', desc: 'O entendimento do tribunal mudou (Overruling).' }
    },

    // 7. DIFICULDADE (ESTATÍSTICA)
    DIFFICULTY: {
        'EASY': { label: 'Fácil', color: 'green' },
        'MEDIUM': { label: 'Média', color: 'yellow' },
        'HARD': { label: 'Difícil', color: 'red' },
        'INSANE': { label: 'Demolidora', color: 'purple' }
    },

    // 8. TIPO DE QUESTÃO
    QUESTION_TYPES: {
        'MULTIPLE_CHOICE': 'Múltipla Escolha (ABCD)',
        'TRUE_FALSE': 'Certo / Errado (Cebraspe)',
        'DISCURSIVE': 'Discursiva / Peça Prática'
    },
    
    // 9. CARGOS (ALVO)
    JOB_ROLES: [
        'Advogado (OAB)', 
        'Juiz de Direito', 
        'Promotor de Justiça', 
        'Defensor Público', 
        'Delegado de Polícia', 
        'Procurador do Estado', 
        'Analista Judiciário', 
        'Técnico Judiciário'
    ]
};